<template>
  <div class="mainApp">
     <Intro v-if="showIntro"></Intro>
    <div style="width:100%" v-if="this.$router.history.current['path'] != '/admin71833920'">
      <Header v-bind:display="display"></Header>
        <router-view @click="hidemenu"/>
      <Findus></Findus>
      <Footer></Footer>
      <Modal v-show="{ isShowing: popup }"></Modal>
    </div>
    <Admin v-if="this.$router.history.current['path'] == '/admin71833920'"></Admin>
  </div>
</template>

<script>
import Intro from "./components/intro.vue";
import Header from "./components/layout/header.vue";
import Findus from "./components/layout/findus.vue";
import Footer from "./components/layout/footer.vue";
import Modal from "./components/layout/modal-app.vue";
import Admin from "./components/adminSection.vue";

export default {

  data() {
    return {
      display:true,
      popup: true,
      showIntro:true
    };
  },
    watch: {
    '$route' () {
      this.display=true;
    },
    
    },

  components: {
    Header,
    Findus,
    Footer,
    Modal,
    Admin,
    Intro
  },

  methods:{
    hidemenu(){
     this.display=true;
   },

  
  },

  created(){
    setTimeout(() => this.showIntro = false, 15000)
  }
};
</script>

<style>
.mainApp {
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  max-width: 100% !important;
  box-sizing: border-box;
}
.fade-enter {
  opacity: 0;
  transform: translateY(-50px);
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.6s ease-in-out, transform 0.6s ease;
}
.fade-enter-active {
  transition-delay: 0.7s;
}
.fade-leave {
  opacity: 1;
  transform: translateY(0px);
}
.fade-enter-to {
  opacity: 1;
  transform: translateY(0px);
}
.fade-leave-to {
  opacity: 0;
  transform: translateY(50px);
}
</style>
